import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { ICountry } from './ICountry.model'

export enum STORE_ACTIONS {
  COUNTRY_STORE_COUNTRIES = 'country/storeCountries'
}

export enum STORE_GETTERS {
  COUNTRY_GET_COUNTRIES = 'country/countries'
}

@Module({ namespaced: true })
export default class CountryStore extends VuexModule {
  private _countries: Array<ICountry> = []

  @Mutation
  private storeCountriesMutation(countries: Array<ICountry> = []): void {
    this._countries = countries || []
  }

  @Action
  public storeCountries(countries: Array<ICountry>): void {
    this.context.commit('storeCountriesMutation', countries)
  }

  private get countries(): Array<ICountry> {
    return this._countries || []
  }
}
